import { useForm, Controller  } from "react-hook-form";

import { useState, useEffect  } from "react";
import  {useDispatch} from "react-redux";
import { setCredentials } from "context/auth/authSlice";
import { useLoginMutation } from "context/auth/authApiSlice";
import useHelper from "hooks/useHelper";
// react-router-dom components
import { Link, useNavigate } from "react-router-dom";
import {Switch, Icon, InputAdornment, LinearProgress, Divider} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "dashboard/components/MDBox";
import MDTypography from "dashboard/components/MDTypography";
import MDInput from "dashboard/components/MDInput";
import MDButton from "dashboard/components/MDButton";
import MDAlert from "dashboard/components/MDAlert";

// Authentication layout components
export default  function SignInForm() {
    const [persist, setPersist] = useState(false);
    const navigate = useNavigate();
    const { isValidEmail } = useHelper();
    const { register, handleSubmit, control, formState: { errors } } = useForm({
        defaultValues:{
            user:'',
            password : ''
    }});
    const [showpassword, setShowPassword] = useState(true);
    const showPassword = () =>setShowPassword(!showpassword);
    const  [errorMsg, setErrorMsg] = useState("");

    const [login, {isLoading}] = useLoginMutation();
    const dispatch = useDispatch();
  
    const onSubmit = async data =>{
    
        const {user,password} = data;
        try{
        const userData = await login({email : user, password}).unwrap();
        dispatch(setCredentials({accessToken : userData.data.accessToken,  user:userData.data.user}));
        setErrorMsg("");
        /* eslint-disable */
        if(["USER","PARTNER"].includes(userData.data.user.isAdmin)){
          navigate("/")
        }else {
          navigate("/dashboard")
        }
        
        } catch(err) {
          let errMsgs = "ERROR : ";
          if(err.status === 401 || err.originalStatus === 401 ){
              errMsgs += `unauthorized access !!, ${err.data.message }`;
          }else if(err.status === 204 || err.originalStatus === 204 || err.originalStatus === 400){
              errMsgs += "unable to connect, user and password don't match !";
          }else if(err.status === 500 ){
              errMsgs += `Server failure, unable to connect` ;
          }else{
            
            errMsgs += `Failure! please contact the support services ${err.error || err.data?.message}`;
          }
          setErrorMsg(`${errMsgs.toString()}`);
        }
    }

    const handleSetRememberMe = () => setPersist(prev => !prev);

    useEffect(() => {
      localStorage.setItem("persist", persist);
    }, [persist])

  return (
    <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="on">
            {isLoading && <LinearProgress color="info"   sx={{ marginBottom:"15px", width:"100%", overflowX:"hidden"}} />}
            <MDBox mb={2}>
                <Controller name="user" control={control} 
                    render={({ field: { onChange, value } }) => (
                    <MDInput   onChange={onChange}   value={value} type="email" label="Email" required fullWidth 
                    {...register("user", { required: "a valide email is required.", validate : isValidEmail })}
                    error={Boolean(errors.user)}
                    helperText={errors.user?.message} />
                    )}
                />
            </MDBox>
            <MDBox mb={2}>
                <Controller name="password" control={control} 
                    render={({ field: { onChange, value } }) => (
                    <MDInput   onChange={onChange} value={value} type={showpassword ? "password" : "text"} label="Password" required fullWidth 
                        {...register("password", { required: "password is required." })}
                        error={Boolean(errors.password)}
                        helperText={errors.password?.message}
                        InputProps={{
                          endAdornment: (
                              <InputAdornment position="end">
                                  <Icon sx={{ cursor:"pointer" }} fontSize="medium"  onClick={showPassword}>{showpassword ? "visibility" : "visibility_off"}</Icon>
                              </InputAdornment>
                          )}}
                         />
                    )}
                    />
            </MDBox>
            <MDBox display="flex" alignItems="center" ml={-1}>
              <Switch checked={persist} onChange={handleSetRememberMe} />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                onClick={handleSetRememberMe}
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;rester connecté
              </MDTypography>
              
            </MDBox>
            <MDBox mt={4} mb={1}>
            {errorMsg && <MDAlert color="error"><small style={{ fontSize:"12px",whiteSpace: "normal" }}> {errorMsg} </small></MDAlert> }
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton  variant="gradient" color="info" type="submit" fullWidth>
                se connecter
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center" >
              <MDTypography variant="button" color="text">
                Mot de passe oublié ? {" "}
                <MDTypography
                  component={Link}
                  to="/authentication/ResetPass"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Récupéré
                </MDTypography>
              </MDTypography>
              <Divider />
              <MDTypography variant="button" color="text">
                pas encore inscrit ? {" "}
                <MDTypography
                    component={Link}
                    to="/authentication/sign-up"
                    variant="button"
                    color="info"
                    fontWeight="medium"
                    textGradient
                  >
                    S'inscrire
                  </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
  )
}
